import { defineStore } from 'pinia'

import messages from 'src/i18n/messages'
import localeService from 'src/services/locale/locale.service.js'

const BACKEND_LANGUAGE_COOKIE_NAME = 'userLanguage'

export const useI18nStore = defineStore('i18n', {
  state: () => ({
    i18n: null,
  }),
  actions: {
    setI18n(newI18n) {
      this.$patch({
        i18n: newI18n.global,
      })
    },
    setLanguage(value) {
      messages.setLanguage(this.i18n, value)
      // a session cookie for the whole site, encoded like js-cookie did
      const backendLocale = localeService.internalToBackendLocaleMulti(value)
      document.cookie = `${BACKEND_LANGUAGE_COOKIE_NAME}=${encodeURIComponent(backendLocale)}; path=/`
    },
  },
})
